/** App: the v2 router, at the root (#704). Every screen loads lazily inside the shell; old addresses redirect (`moved.ts`). */
import { lazy } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { movedRoutes } from "./moved";
import { galleryRoutes } from "./replica";
import { OneSheet } from "./oneSheet";
import { NotFound, RouteError } from "./RouteError";
import { screenLoaders } from "./screens";
import { Shell } from "./Shell";

const Today = lazy(screenLoaders.today);
const People = lazy(screenLoaders.people);
const Events = lazy(screenLoaders.events);
const Email = lazy(screenLoaders.email);
const Money = lazy(screenLoaders.money);
const Settings = lazy(screenLoaders.settings);
const Labs = lazy(screenLoaders.labs);

const router = createBrowserRouter(
  [
    ...galleryRoutes,
    ...movedRoutes,
    {
      path: "/",
      element: (
        <>
          <OneSheet />
          <Shell />
        </>
      ),
      // The shell itself failed: the error stands alone on the page.
      errorElement: (
        <div className="p-6">
          <RouteError />
        </div>
      ),
      children: [
        {
          // A pathless layer so a screen that fails keeps the shell around its error.
          errorElement: <RouteError />,
          children: [
            { index: true, element: <Today /> },
            { path: "people", element: <People /> },
            { path: "events", element: <Events /> },
            { path: "events/:ref", element: <Events /> },
            { path: "email", element: <Email /> },
            { path: "money", element: <Money /> },
            { path: "settings", element: <Settings /> },
            { path: "settings/imports", element: <Settings /> },
            { path: "labs/:id", element: <Labs /> },
            { path: "*", element: <NotFound /> },
          ],
        },
      ],
    },
  ],
);

export function App() {
  return <RouterProvider router={router} />;
}
